import { Reducer } from 'redux';

import { ExperimentAnalysisConfigView } from '../../../lib/PlannerDTOs';
import { ActionType } from '../../../store/actionTypes';
import {
  ActionWithPlayload,
  EntityAction,
  ErrorAction,
  isActionWithPayload,
} from '../../../store/types';

export interface AnalysisConfigState {
  [experimentName: string]: {
    isFetching: boolean;
    error?: string;
    analysisConfig: ExperimentAnalysisConfigView;
  };
}

export const initialState: AnalysisConfigState = {};

type Action =
  | ActionWithPlayload<ActionType.FETCH_EXPERIMENT_ANALYSIS_CONFIG_STARTED>
  | EntityAction<ActionType.FETCH_EXPERIMENT_ANALYSIS_CONFIG_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_EXPERIMENT_ANALYSIS_CONFIG_FAILED>;

export const analysisConfigReducer: Reducer<AnalysisConfigState, Action> = (
  state: AnalysisConfigState = initialState,
  action: Action,
) => {
  if (isActionWithPayload(action)) {
    const experimentName = action.payload.experimentName;

    switch (action.type) {
      case ActionType.FETCH_EXPERIMENT_ANALYSIS_CONFIG_STARTED:
        return {
          ...state,
          [experimentName]: {
            isFetching: true,
          },
        };
      case ActionType.FETCH_EXPERIMENT_ANALYSIS_CONFIG_SUCCEEDED:
        return {
          ...state,
          [experimentName]: {
            isFetching: false,
            analysisConfig: state[experimentName].analysisConfig,
          },
        };
      case ActionType.FETCH_EXPERIMENT_ANALYSIS_CONFIG_FAILED:
        return {
          ...state,
          [experimentName]: {
            isFetching: false,
            error: action.payload.message,
          },
        };
      default:
        return state;
    }
  }

  return state;
};

export default analysisConfigReducer;
